import { useStore } from 'effector-react'
import { BaseSyntheticEvent } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { phoneMaskOptions } from '~/shared/lib/maskito'
import { Button } from '~/shared/ui/Buttons'
import { MaskInput } from '~/shared/ui/form'
import { FormProvider } from '~/shared/ui/form/FormProvider/FormProvider'
import { requestLoginCodeFx } from '../model'
import { LoginStepTitle, GridContainer, GridItem } from '../styled'
import { LoginPhoneFormValues } from './model'

type StepLoginPhoneProps = {
  form: UseFormReturn<LoginPhoneFormValues>
  onSuccess: () => Promise<void>
}

export function StepLoginPhone({ form, onSuccess }: StepLoginPhoneProps) {
  const isRequestLoginCodePending = useStore(requestLoginCodeFx.pending)

  const handleOnSuccess = (
    _: LoginPhoneFormValues,
    event?: BaseSyntheticEvent,
  ) => {
    event?.preventDefault()
    onSuccess()
  }

  return (
    <FormProvider form={form} onSuccess={handleOnSuccess}>
      <LoginStepTitle>
        Авторизуйтесь, чтобы иметь полный доступ к функционалу
      </LoginStepTitle>
      <GridContainer>
        <GridItem>
          <MaskInput
            maskitoOptions={phoneMaskOptions}
            name='phone'
            label='Номер телефона'
            disabled={isRequestLoginCodePending}
            autocomplete='on'
          />
        </GridItem>
        <GridItem>
          <Button
            variant='limeFlooded'
            loading={isRequestLoginCodePending}
            fullWidth
            type='submit'
          >
            Получить код
          </Button>
        </GridItem>
      </GridContainer>
    </FormProvider>
  )
}
